export default __webpack_public_path__ + "static/media/fake_anomaly_graph.9df9ff48.png";